export default "__VITE_ASSET__CDRa70k0__"